/**
 * Azure Authentication Hook
 * 
 * Simplified hook for components to use Azure authentication
 */

import { useMsal } from '@/contexts/MsalContext';

export interface AzureAuthUser {
  username: string;
  name: string;
  email: string;
}

export const useAzureAuth = () => {
  const {
    isInitialized,
    isAuthenticated,
    account,
    accessToken,
    isLoading,
    error,
    login,
    logout,
    getToken,
  } = useMsal();

  // Extract user info from account
  const user: AzureAuthUser | null = account
    ? {
        username: account.username,
        name: account.name || account.username,
        email: account.username,
      }
    : null;

  return {
    // State
    isInitialized,
    isAuthenticated,
    isLoading,
    error,
    user,
    accessToken,

    // Actions
    login,
    logout,
    getToken,
  };
};
